export default {
  p: { x: 416, y: 255 },
  r: 30,
  s: [],
  b: [
    { x: 400, y: 220 },
    { x: 272, y: 380 },
    { x: 302, y: 380 },
    { x: 332, y: 380 },
    { x: 362, y: 380 },
    { x: 432, y: 380 },
    { x: 462, y: 380 },
    { x: 492, y: 380 },
  ],
  g: [{ x: 384, y: 270 }],
  h: [
    { x: 550, y: 290 },
    { x: 400, y: 190 },
  ],
};
